import styled from 'styled-components'
import { SCREEN_SIZE, STYLES } from '../../static/style'

const DropdownMenu = styled.div`
  position: absolute;
  box-shadow: 1px 1px 5px #333;
  border-radius: ${STYLES.BORDER_RADIUS};
  margin-top: 2px;
  background-color: ${STYLES.COLOR_WHITE};
  min-width: 100%;
  width: 95vw;
  left: 0;
  z-index: 5;
  ${SCREEN_SIZE.SM} {
    width: auto;
    left: initial;
  }
}
`

export { DropdownMenu }
